import { IMemberEvent } from '@shared/shared/interfaces/member-event.interfaces';
import * as fromActions from '../actions/member-event.actions';

export const initialState: IMemberEvent = {
  adult_ticket_price: null,
  adult_ticket_price_currency: null,
  child_ticket_price: null,
  child_ticket_price_currency: null,
  type: null,
};

export function reducer(state = initialState, action: fromActions.MemberEventActions) {
  switch (action.type) {
    case fromActions.GET_EVENT:
      return initialState;

    case fromActions.GET_EVENT_SUCCESS:
      return action.payload;

    default:
      return state;
  }
}
